/** Arduino IDE-style compile summary lines from arduino-cli output. */
const PROGRAM_STORAGE_LINE =
  /^Sketch uses .+ of program storage space\./i;
const GLOBAL_MEMORY_LINE =
  /^Global variables use .+ of dynamic memory,.+\./i;

/**
 * Extracts the short program/memory summary from a compile or upload log,
 * matching what the Arduino IDE shows after a successful upload.
 */
export function formatUploadSummary(log: string): string | null {
  const summary: string[] = [];

  for (const line of log.split(/\r?\n/)) {
    const trimmed = line.trim();
    if (!trimmed) {
      continue;
    }

    if (PROGRAM_STORAGE_LINE.test(trimmed)) {
      summary.push(trimmed);
      continue;
    }

    if (GLOBAL_MEMORY_LINE.test(trimmed)) {
      summary.push(trimmed);
    }
  }

  if (summary.length === 0) {
    return null;
  }

  return summary.join('\n');
}
